import script from "./IDESideBarContentTabSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBarContentTabSettings.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBarContentTabSettings.vue?vue&type=style&index=0&id=9839bd8a&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9839bd8a"]])

export default __exports__